import qs from 'qs';
import { useHistory, Redirect } from 'react-router-dom';
import React, { useEffect } from 'react';

const PrivateRoute = ({ userStore, component: Component, location }) => {
  const history = useHistory();
  const query = qs.parse(window.location.search.substring(1));

  useEffect(() => {
    if (!userStore.isLoggedIn && query.code) {
      (async () => {
        await userStore.loginWithCode(query.code);
        history.push(window.location.pathname);
      })();
    }
  }, []);

  if (!userStore.isLoggedIn && query.code) {
    return <></>;
  }

  if (!userStore.loggedIn) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { referrer: location.pathname }
        }}
      />
    );
  }

  if (
    location.pathname.startsWith('/search') &&
    !userStore.hasAccess('prospecting')
  ) {
    return <div />;
  }

  return <Component />;
};

export default PrivateRoute;
